import { create, StateCreator } from "zustand"
import { devtools, persist  } from "zustand/middleware"

export const createStore = <T>(fn: StateCreator<T>, name: string) => {
  return create<T>()(
    devtools(
      persist((set, get, api) => {
        const state = fn(set, get, api)

        if (import.meta.env.DEV) {
          console.log(`🟢 [Zustand] create store: ${name}`)
          console.log(`📦 [Zustand] initial state:`, state)
        }

        return state
      }, {
        name,
      }),
      { name }
    )
  )
}